'use client';

import { useRoutePattern } from '@framework/next/navigation';
import { Tracer } from './../react/Tracer';

const PageLoadInstrumentation = ({ children }: React.PropsWithChildren) => {
  const page = useRoutePattern();

  return (
    <Tracer.StartActiveSpan
      name="page.load"
      options={ {
        attributes: {
          page,
        },
      } }
    >
      { children }
    </Tracer.StartActiveSpan>
  );
};

export default PageLoadInstrumentation;
